var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('table',{staticClass:"table is-fullwidth"},[_c('tbody',_vm._l((_vm.cells),function(item,index){return _c('tr',{key:index},[_c('table-cell-component',{attrs:{"bus":_vm.bus,"cell_item":item}})],1)}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }